'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browserLoad = require('./browser-load');

Object.defineProperty(exports, 'loadFile', {
  enumerable: true,
  get: function get() {
    return _browserLoad.loadFile;
  }
});
Object.defineProperty(exports, 'loadImage', {
  enumerable: true,
  get: function get() {
    return _browserLoad.loadImage;
  }
});

var _loadFiles = require('./load-files');

Object.defineProperty(exports, 'loadFiles', {
  enumerable: true,
  get: function get() {
    return _loadFiles.loadFiles;
  }
});
Object.defineProperty(exports, 'loadImages', {
  enumerable: true,
  get: function get() {
    return _loadFiles.loadImages;
  }
});
Object.defineProperty(exports, 'loadTextures', {
  enumerable: true,
  get: function get() {
    return _loadFiles.loadTextures;
  }
});
Object.defineProperty(exports, 'loadProgram', {
  enumerable: true,
  get: function get() {
    return _loadFiles.loadProgram;
  }
});
Object.defineProperty(exports, 'loadModel', {
  enumerable: true,
  get: function get() {
    return _loadFiles.loadModel;
  }
});
Object.defineProperty(exports, 'parseModel', {
  enumerable: true,
  get: function get() {
    return _loadFiles.parseModel;
  }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pby9pbmRleC5qcyJdLCJuYW1lcyI6WyJsb2FkRmlsZSIsImxvYWRJbWFnZSIsImxvYWRGaWxlcyIsImxvYWRJbWFnZXMiLCJsb2FkVGV4dHVyZXMiLCJsb2FkUHJvZ3JhbSIsImxvYWRNb2RlbCIsInBhcnNlTW9kZWwiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O3dCQUNRQSxROzs7Ozs7d0JBQVVDLFM7Ozs7Ozs7OztzQkFDVkMsUzs7Ozs7O3NCQUFXQyxVOzs7Ozs7c0JBQVlDLFk7Ozs7OztzQkFDdkJDLFc7Ozs7OztzQkFBYUMsUzs7Ozs7O3NCQUFXQyxVIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ2FsbCBhIHJlcXVpcmUgYmFzZWQgaGVscGVyIHRvIHNlbGVjdCBwbGF0Zm9ybSB0byBleHBvcnRcbmV4cG9ydCB7bG9hZEZpbGUsIGxvYWRJbWFnZX0gZnJvbSAnLi9icm93c2VyLWxvYWQnO1xuZXhwb3J0IHtsb2FkRmlsZXMsIGxvYWRJbWFnZXMsIGxvYWRUZXh0dXJlc30gZnJvbSAnLi9sb2FkLWZpbGVzJztcbmV4cG9ydCB7bG9hZFByb2dyYW0sIGxvYWRNb2RlbCwgcGFyc2VNb2RlbH0gZnJvbSAnLi9sb2FkLWZpbGVzJztcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/io/index.js
// module id = 565
// module chunks = 0